import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Globe, MessageCircle } from "lucide-react";
import {
  COMPANY,
  PHONE_DISPLAY,
  PHONE_TEL,
  EMAIL,
  WEBSITE,
  ADDRESS,
  waLink,
} from "../data/site";

export const Footer = () => (
  <footer className="bg-[#0d1f18] text-white/80" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img
              src="/logo.jpeg"
              alt="Organik Things logo"
              className="h-11 w-11 object-contain rounded-full bg-white"
            />
            <div>
              <p className="font-heading font-bold text-white">{COMPANY}</p>
              <p className="text-xs">Natural Alternatives. A Greener Tomorrow.</p>
            </div>
          </div>
          <p className="mt-4 text-sm text-white/60 leading-relaxed">
            Eco-friendly, biodegradable leaf plates, bowls, thalis and grass
            straws for businesses, distributors and bulk buyers across India.
          </p>
        </div>
        <div>
          <p className="font-heading font-semibold text-white mb-4">Quick Links</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-white" data-testid="footer-link-home">Home</Link></li>
            <li><Link to="/about" className="hover:text-white" data-testid="footer-link-about">About Us</Link></li>
            <li><Link to="/products" className="hover:text-white" data-testid="footer-link-products">Products</Link></li>
            <li><Link to="/dealership" className="hover:text-white" data-testid="footer-link-dealership">Dealer & Distribution</Link></li>
            <li><Link to="/contact" className="hover:text-white" data-testid="footer-link-contact">Contact Us</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-heading font-semibold text-white mb-4">Contact</p>
          <ul className="space-y-3 text-sm">
            <li>
              <a href={PHONE_TEL} className="flex items-center gap-2.5 hover:text-white" data-testid="footer-phone">
                <Phone className="w-4 h-4 shrink-0" /> {PHONE_DISPLAY}
              </a>
            </li>
            <li>
              <a href={`mailto:${EMAIL}`} className="flex items-center gap-2.5 hover:text-white break-all" data-testid="footer-email">
                <Mail className="w-4 h-4 shrink-0" /> {EMAIL}
              </a>
            </li>
            <li className="flex items-center gap-2.5">
              <Globe className="w-4 h-4 shrink-0" /> {WEBSITE}
            </li>
            <li className="flex items-start gap-2.5 text-white/60" data-testid="footer-address">
              <MapPin className="w-4 h-4 shrink-0 mt-0.5" /> {ADDRESS}
            </li>
            <li>
              <a
                href={waLink("Hello Organik Things, I would like to make a business enquiry.")}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#95d5b2] hover:text-white"
                data-testid="footer-whatsapp"
              >
                <MessageCircle className="w-4 h-4" /> Chat on WhatsApp
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-10 pt-6 border-t border-white/10 text-xs text-white/50 text-center">
        © {new Date().getFullYear()} {COMPANY} · {WEBSITE} · All rights reserved.
      </div>
    </div>
  </footer>
);
